var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgComingSoonIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Rectangle 21202",
    fill: "none",
    d: "M0 0h24v24H0z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    "data-name": "megaphone (1)",
    d: "M19.783 13.151a18.6 18.6 0 00-7.748 2.028l-3.011 1.738a1.664 1.664 0 01-2.271-.609l-1.531-2.65a1.664 1.664 0 01.609-2.271l2.5-1.441a.3.3 0 01.413.111l1.961 3.4a.3.3 0 00.42.106.31.31 0 00.1-.419L9.242 9.719a.3.3 0 01.089-.4 18.594 18.594 0 005.141-5.367 1.265 1.265 0 012.165.042l4.192 7.261a1.264 1.264 0 01-1.046 1.896zm.538-5.057a1.891 1.891 0 00-1.207-2.084.3.3 0 00-.364.436l1.01 1.75a.3.3 0 00.561-.102zm-6.974 10.691l-1.434-2.489a.3.3 0 00-.413-.111l-1.843 1.064a.3.3 0 00-.111.413l1.436 2.487a.982.982 0 00.852.492c.327 0 .452-.111 1.152-.515a.983.983 0 00.361-1.341z"
  })));
}
export default SvgComingSoonIcon;